import React, { useEffect, useState } from "react";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import right_arrow from "../../resources_catalog/icons/ico_right_arrow.svg";
import catalog_title_img from "../../resources_catalog/images/catalog_title_img.svg";
import catalog_step_img01 from "../../resources_catalog/images/catalog_step_img01.svg";
import catalog_step_img02 from "../../resources_catalog/images/catalog_step_img02.svg";
import catalog_step_img03 from "../../resources_catalog/images/catalog_step_img03.svg";
import catalog_step_img04 from "../../resources_catalog/images/catalog_step_img04.svg";
import catalog_step_img05 from "../../resources_catalog/images/catalog_step_img05.svg";
import travelConditionsJpPdf from "../../resources_catalog/pdf/国内海外手配旅行 旅行条件書（RTCC宿泊プラン）.pdf"
import passportPdf from "../../resources_catalog/pdf/ビザ・パスポート情報.pdf"
import participationPdf from "../../resources_catalog/pdf/ご参加にあたって.pdf"
import hotelPdf from "../../resources_catalog/pdf/ホテルについて.pdf"
import entryConditionsPdf from "../../resources_catalog/pdf/渡航先の入国条件ならびに日本帰国時の入国条件について.pdf"
import anchor_blank from "../../resources_catalog/icons/anchor_blank.svg";
import { useRtoaster } from "../../hooks/useRtoaster";

export const CatalogHowtoJpContainer = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  const [linkList, setLinkList] = useState([]);
  const onClickBack = () => {
    history.push(props.path);
  }
  const onClickReserve = () => {
    history.push("/reserve/rtcc/reservation");
  }

  // rtoasterタグ生成
  useRtoaster();

  useEffect(() => {
    setLinkList([{ path: "/rtcc/catalog/home", label: "ホーム" }]);
  }, []);

  return (
    <div className="catalogContentWrap">
      <div className="catalogContent">
        <div className="catlogBackBlock"></div>
        <div className="catalogContentsBlock">
          <div className="catalogContentsTitle">
            <img src={catalog_title_img} alt="" className="catalogContentsTitleImg" />
            <p>RTCC宿泊{isWideTablet ? <br /> : " "}ホテル予約方法</p>
            <p className="catalogContentsTitleCaption">HOW TO REQUEST</p>
          </div>
          <div className="catalogContentsHowto">
            <p className="catalogContentsHowtoMidiumTitle">ご利用方法</p>
            <div className="catalogContentsHowtoList">
              <img src={catalog_step_img01} alt="" className="catalogContentsHowtoListImg" />
              <div className="catalogContentsHowtoSmallTitleWrap">
                <div className="catalogContentsHowtoSmallTitleRequest">予約</div>
                <p className="catalogContentsHowtoSmallTitle">
                  RTTGアプリまたは、<a href="/reserve/rtcc/reservation">ＲＴＣＣ予約サイト<img src={anchor_blank} alt="" className="catalogContentsHowtoSmallTitleAnchorImg" /></a>にログインしてお好みの宿泊プランを検索します<br />
                  <div style={{ fontSize: "small" }}>※ネット予約にはRTTGポイントクラブへのご登録（会員権ひも付け登録を含む）が必要となります。</div></p>
              </div>
              <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">
                  下記を指定して宿泊施設を検索の上、一覧表示された施設の中からご希望の施設を選択してください。
                </p>
              </p>
              <p className="catalogPointAttentionSpacify">都市、チェックイン日、チェックアウト日、室数、一室あたりのご利用人数、<br />1室毎の大人・こどもの内訳及び子供のチェックイン時の実年齢</p>
              <ul className="catalogPointAttentionListWrap">
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    一度のお申込みでご予約いただける宿泊施設は1件、部屋数は最大3部屋まで同時に選択することができます。
                  </p>
                </li>
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    複数部屋をご希望で、それぞれご利用人数が異なる場合、１度に予約はできませんので、部屋毎にご予約下さい。
                  </p>
                </li>
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    宿泊日・宿泊数の検索条件及び空室状況によっては、検索結果に表示されない場合があります。
                  </p>
                </li>
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    予約されるホテルやプランによっては13歳以上のお子様は大人として扱わせていただく場合がございます。
                  </p>
                </li>
                {/* <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    キーワード検索でホテル名等をご入力いただき、絞り込むことも可能です。
                  </p>
                </li> */}
              </ul>
              <div className="catalogContentsButton" onClick={onClickReserve}>
                <p>会員予約サイトへログイン</p>
                <img src={right_arrow} alt="" />
              </div>
            </div>
            <div className="catalogContentsHowtoList">
              <img src={catalog_step_img02} alt="" className="catalogContentsHowtoListImg" />
              <div className="catalogContentsHowtoSmallTitleWrap">
                <div className="catalogContentsHowtoSmallTitleRequest">予約</div>
                <p className="catalogContentsHowtoSmallTitle">
                  ご希望のお部屋の選択</p>
              </div>
              <p className="catalogContentsHowtoText marginBottomNone">ご希望の宿泊施設を選択して、一覧表示された宿泊プラン(部屋カテゴリー)の中からご希望のプランを選択してください。</p>
            </div>
            <div className="catalogContentsHowtoList">
              <img src={catalog_step_img03} alt="" className="catalogContentsHowtoListImg" />
              <div className="catalogContentsHowtoSmallTitleWrap">
                <div className="catalogContentsHowtoSmallTitleRequest">予約</div>
                <p className="catalogContentsHowtoSmallTitle">
                  お客様情報のご入力</p>
              </div>
              <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">ご宿泊代表者・同行者の下記情報を入力してください。</p>
              </p>
              <p className="catalogPointAttentionSpacify">ご宿泊代表者情報-氏名（漢字・カナ）、氏名（半角英字）、生年月日、性別、住所、電話番号、メールアドレス<br />
                同行者情報　-氏名（漢字・カナ）、氏名（半角英字）、生年月日、性別
              </p>
              <ul className="catalogPointAttentionListWrap">
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                  海外施設を予約の場合、氏名（半角英字）にはパスポート記載のお名前（英語表記）をご入力ください。
                  </p>
                </li>
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    メールアドレスに誤りがあった場合、予約完了メールを受け取ることができなくなります。ご記入いただく際はお間違えの無いよう十分ご注意ください。
                  </p>
                </li>
              </ul>
              {/* <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">部屋ごとのご利用人数の詳細を正確にご入力下さい。 部屋割り＆人数に応じ料金が計算されます。</p>
              </p>
              <p className="catalogPointAttentionSpacify">大人、こども、こども（添い寝）</p>
              <ul className="catalogPointAttentionListWrap">
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    各施設の定員内でのご入力をお願いいたします。
                  </p>
                </li>
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    「こども（添い寝）」は、11才以下のお子様が対象です。
                  </p>
                </li>
              </ul> */}
              <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">クレジットカードかお振込みのどちらかのお支払い方法を選択ください。</p>
              </p>
              <p className="catalogPointAttentionSpacify">クレジットカード一括払い（オンライン決済可能）、お振込み一括払い</p>
              <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">お申込みに関する全ての条件をご確認下さい</p>
              </p>
              <ul className="catalogPointAttentionAgreementWrap">
                <li className="catalogPointAttentionAgreement">
                  <p className="catalogPointAttentionListText">
                  (1) 国内手配旅行
                  </p>
                </li>
              </ul>
              <ul className="catalogContentsHowtoPdfList">
                <li><a href={travelConditionsJpPdf} target="_blank" rel="noopener noreferrer">旅行条件書</a></li>
              </ul>
              <ul className="catalogPointAttentionAgreementWrap">
                <li className="catalogPointAttentionAgreement">
                  <p className="catalogPointAttentionListText">
                  (2) 海外手配旅行
                  </p>
                </li>
              </ul>
              <ul className="catalogContentsHowtoPdfList">
              <li><a href={travelConditionsJpPdf} target="_blank" rel="noopener noreferrer">旅行条件書</a></li>
                <li><a href={passportPdf} target="_blank" rel="noopener noreferrer">パスポートの有効期間をご確認ください。</a></li>
                <li><a href={participationPdf} target="_blank" rel="noopener noreferrer">ご参加にあたって</a></li>
                <li><a href={hotelPdf} target="_blank" rel="noopener noreferrer">ホテルについて</a></li>
                <li><a href={entryConditionsPdf} target="_blank" rel="noopener noreferrer">渡航先の入国条件ならびに日本帰国時の入国条件について</a></li>
              </ul>
            </div>
            <div className="catalogContentsHowtoList">
              <img src={catalog_step_img04} alt="" className="catalogContentsHowtoListImg" />
              <div className="catalogContentsHowtoSmallTitleWrap">
                <div className="catalogContentsHowtoSmallTitleRequest">予約</div>
                <p className="catalogContentsHowtoSmallTitle">
                  旅行代金のお支払いとご予約の確定</p>
              </div>
              <p className="catalogContentsHowtoText">
                予約内容を確認後にご決済頂きます（クレジットカード払いのみ）<div style={{ fontSize: "small" }}>※ご利用可能なクレジットカード: JCB、VISA、Mastercard</div><br />
                クレジットカードでのお支払いは一括払いのみとなります。<br />
                お引き落としは決済日がカードのご利用日となり、お引き落とし日は各カード会社で定められた日となります。（チェックイン日とは関係ありません。）<br />
                決済が完了した時点でお客様のご予約が確定します。</p>
              <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">お振込みの場合は、予約完了メールにてお振込み情報をご案内いたします。ご案内の期日までに、下記の銀行口座までお振込みください。</p>
              </p>
              <div className="catalogContentsHowtotransferWrap">
                <div className="catalogContentsHowtoTransfer">
                  <p className="catalogContentsHowtoTransferText">RTCC宿泊（国内・海外手配旅行）<br />振込先</p>
                  <p className="catalogContentsHowtoTransferAttention">※振込手数料は利用者様のご負担となります。</p>
                </div>
                <div className="catalogContentsHowtoBank">
                  <p className="catalogContentsHowtoBankBranch">みずほ銀行　第十集中支店(834) </p>
                  <p className="catalogContentsHowtoBankAccount">当座1092508　リゾートトラスト株式会社</p>
                </div>
              </div>
              <ul className="catalogPointAttentionListWrap marginBottomNone">
                <li className="catalogPointAttentionList">
                  <p className="catalogPointAttentionListText">
                    期日までにお支払いが確認できない場合は、確保した客室が取り消される場合がございますのでご注意下さい。
                  </p>
                </li>
              </ul>
              <ul className="catalogPointAttentionCommentList">
                <li>
                  <p className="catalogPointAttentionCommentListText">予約完了後、ご予約内容を印刷するか、ご自身のパソコンに保存し、必ずお読みください。</p>
                </li>
              </ul>
              <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">変更をご希望の場合には、一旦取り消しの後、新規にご予約となります。（ご利用日の15日前まで可能） </p>
              </p>
              <p className="catalogPointAttention">
                <p className="catalogPointAttentionText">入湯税、宿泊税が必要な場合は現地精算となります。予めご了承ください。</p>
              </p>
            </div>
            <div className="catalogContentsHowtoList">
              <img src={catalog_step_img05} alt="" className="catalogContentsHowtoListImg" />
              <div className="catalogContentsHowtoSmallTitleWrap">
                <div className="catalogContentsHowtoSmallTitleRequest">出発</div>
                <p className="catalogContentsHowtoSmallTitle">
                  「予約完了メール」を印刷頂きご持参ください</p>
              </div>
              <p className="catalogContentsHowtoText marginBottomNone">「RTCC宿泊（国内・海外手配旅行）」では事前送付物はございません。<br />
                国内施設へのチェックインの際は、予約完了メールとともに、宿泊代表者様の運転免許証など写真付身分証明書をホテルフロントにご提示ください。<br />
                海外施設へのチェックインの際は、ホテル・コンファメーション・スリップ（予約確認書）とともに、宿泊者全員のパスポートなどをホテルフロントにご提示ください。<br />
                （ただし、一部のホテルでは予約確認書や身分証明書の提示が求められない場合もございます。）
              </p>
            </div>
          </div>
        </div >
      </div >
      <div className={isWideTablet ? "none" : "catalogBreadCrumb"}>
        {linkList.map((value, index) => (
          <div key={"link" + index} style={{ display: "flex" }}>
            <Link to={value.path} className="link">{value.label}</Link>
            <div className="lastLabel">&gt;</div>
          </div>
        ))}
        <div className="lastLabel">RTCC宿泊ホテル予約方法</div>
      </div>
    </div >
  );
};
